/**
 * Property type mapping from numeric IDs to API category strings
 */
export enum PropertyTypeApiMapping {
    Apartment = 63,
    Chalet = 82,
    Hotel = 2,
    Guesthouse = 3,
    Pension = 4,
    Villa = 127,
    RuralTourism = 1,
    HolidayHome = 243,
    Unknown = 277,
    Hostel = 71,
    Sanatorium = 162,
    StudentHostel = 5,
    Motel = 84,
    Resort = 61,
    Inn = 125,
    WorkerAccommodation = 186,
    // Unknown = 0,
}
